import { render, staticRenderFns } from "./ImportLogs.vue?vue&type=template&id=56fb5cfa&"
import script from "./ImportLogs.vue?vue&type=script&lang=js&"
export * from "./ImportLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QTable,QInput,QIcon} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QTable,QInput,QIcon})
